import React from "react";
import RequestEngine from "../../core/RequestEngine";
import strings from "../../core/translate";
import Constants from "../../core/Constants";
import { apiErrorMessage } from "../../shared/api-error";
import {
  FormSection,
  Field,
  FormAlert,
  FormActions,
} from "../../components/Form/FormKit";

// Uploads garage photos. Adding accepts several files at once; editing
// replaces the picture of one existing photo.
export default class BranchPhotoForm extends React.Component {
  constructor(props) {
    super(props);
    const item = props.item || {};
    this.state = {
      id: item.id || "",
      version: item.version,
      currentUrl: item.url || "",
      files: [],
      loading: false,
      error: "",
      fieldError: "",
    };
    this.engine = new RequestEngine();
    this.fileInputRef = React.createRef();
  }

  componentWillUnmount() {
    this.state.files.forEach((file) => URL.revokeObjectURL(file.preview));
  }

  handleSelectFiles = (event) => {
    const selected = Array.from(event.target.files || []);
    event.target.value = "";
    if (selected.length === 0) return;

    const files = this.state.id
      ? selected.slice(0, 1) // editing replaces a single picture
      : selected;

    this.setState((prev) => {
      if (prev.id) {
        prev.files.forEach((file) => URL.revokeObjectURL(file.preview));
      }
      const mapped = files.map((file) => ({
        file,
        preview: URL.createObjectURL(file),
      }));
      return {
        files: prev.id ? mapped : [...prev.files, ...mapped],
        fieldError: "",
      };
    });
  };

  handleRemove = (index) => {
    this.setState((prev) => {
      const files = [...prev.files];
      URL.revokeObjectURL(files[index].preview);
      files.splice(index, 1);
      return { files };
    });
  };

  handleSubmit = async (event) => {
    event.preventDefault();
    const { id, version, files } = this.state;

    if (files.length === 0) {
      this.setState({ fieldError: strings.photo_required_hint });
      return;
    }

    this.setState({ loading: true, error: "", fieldError: "" });
    const pathname = `merchant-branch/${this.props.branchId}/photos`;

    try {
      if (id) {
        const formData = new FormData();
        formData.append("file", files[0].file);
        formData.append("version", version);
        await this.engine.putItemMultipart(pathname, id, formData);
      } else {
        for (const item of files) {
          const formData = new FormData();
          formData.append("file", item.file);
          await this.engine.postItemMultipart(pathname, formData);
        }
      }
      this.setState({ loading: false });
      this.props.onSaved();
      return;
    } catch (err) {
      this.setState({ error: apiErrorMessage(err) });
    }
    this.setState({ loading: false });
  };

  render() {
    const { id, currentUrl, files, loading, error, fieldError } = this.state;

    return (
      <form className="mform" onSubmit={this.handleSubmit}>
        <FormSection title={strings.photos} icon="nc-icon nc-album-2">
          <Field
            label={id ? strings.picture : strings.photos}
            required
            error={fieldError}
            help={id ? strings.photo_replace_hint : strings.photo_multi_hint}
          >
            <div className="garage-form__gallery">
              {id && currentUrl && files.length === 0 && (
                <div className="garage-form__thumb">
                  <img
                    src={`${Constants.serverlink}${currentUrl}`}
                    alt={strings.garage}
                  />
                </div>
              )}

              {files.map((file, index) => (
                <div className="garage-form__thumb" key={file.preview}>
                  <img src={file.preview} alt={strings.garage} />
                  <button
                    type="button"
                    onClick={() => this.handleRemove(index)}
                  >
                    &times;
                  </button>
                </div>
              ))}

              <button
                type="button"
                className="garage-form__add-photo"
                onClick={() =>
                  this.fileInputRef.current && this.fileInputRef.current.click()
                }
              >
                +
              </button>
            </div>
          </Field>

          <input
            ref={this.fileInputRef}
            type="file"
            accept="image/*"
            multiple={!id}
            style={{ display: "none" }}
            onChange={this.handleSelectFiles}
          />
        </FormSection>

        <FormAlert>{error}</FormAlert>
        <FormActions onCancel={this.props.onCancel} loading={loading} />
      </form>
    );
  }
}
